<template lang="pug">
.container
  el-header
    h4
      span {{$t('All Media With Exceptions')}} - {{ currentUserNetwork.name }}
      br
    hr.header
  .container-content
    h4(v-if='noExceptionsInNetwork')  {{ $t('No Exceptions in Network') }}
    h4(v-if='mediaExceptionsForbidden.length > 0') {{ $t('Play Forbidden In Players:') }}
    MediaExceptionsRow(
      v-for='(exception, index) in mediaExceptionsForbidden',
      :id="'medium' + exception.Medium + index",
      :key='"forbid" + exception.Medium + index',
      :exception='exception',
      :type='"playForbiddenInMedia"',
      :showThumnail='true',
      @loadMediumEditor='loadMediumEditor',
      @loadPlayListEditor='loadPlayListEditor'
    )
    hr.header
    h4(v-if='mediaExceptionsAllowed.length > 0') {{ $t('Play Only In Players:') }}
    MediaExceptionsRow(
      v-for='(exception2, index) in mediaExceptionsAllowed',
      :id="'medium' + exception2.Medium + index",
      :key='"allow" + exception2.Medium + index',
      :exception='exception2',
      :type='"playOnlyInMedia"',
      :showThumnail='true',
      @loadMediumEditor='loadMediumEditor',
      @loadPlayListEditor='loadPlayListEditor'
    )
  el-dialog(:close-on-click-modal="false", title='', :visible.sync='mediumEditedId', @close='closeMediumEditor()', append-to-body, width='80%')
    MediumBasicEditor(id="Exceptions-mediumBasicEditor" v-if='mediumEditedId', :mediumId='mediumEditedId', @close='closeMediumEditor()')
  el-dialog(:close-on-click-modal="false", title='', :visible.sync='playListEditedId', @close='closePlayListEditor()', append-to-body, width='80%')
    PlayListEditor(id="Exceptions-mediumBasicEditor" v-if='playListEditedId', :playList='{ id: playListEditedId }', @close='closePlayListEditor()')
</template>

<script>

import Vue from 'vue'
import userUtils from '../Common/userUtils.mixin'
import MediaExceptionsRow from './MediaExceptionsRow'
import MediumBasicEditor from './MediumBasicEditor'
import PlayListEditor from './PlayListEditor'

export default {
  props: [],
  mixins: [userUtils],
  components: {
    MediaExceptionsRow,
    MediumBasicEditor,
    PlayListEditor
  },
  async created () {
    await this.loadData()
  },
  watch: {
    foo: async function (newVal, oldVal) {
    }
  },
  data () {
    return {
      errors: [],
      mediaExceptionsForbidden: [],
      mediaExceptionsAllowed: [],
      mediumEditedId: undefined,
      playListEditedId: undefined
    }
  },
  methods: {
    async loadData () {
      const allExceptions = (await Vue.axios.post(`medium/getMediaWithExceptions`, {})).data
      this.mediaExceptionsForbidden = allExceptions.filter(e => e.playForbiddenInMedia.length > 2)
      this.mediaExceptionsAllowed = allExceptions.filter(e => e.playOnlyInMedia.length > 2)
      console.log(this.mediaExceptionsForbidden)
    },
    closeMediumEditor () {
      this.mediumEditedId = undefined
      this.loadData()
    },
    loadMediumEditor (mediumId) {
      this.mediumEditedId = mediumId
    },
    closePlayListEditor () {
      this.playListEditedId = undefined
      this.loadData()
    },
    loadPlayListEditor (playListEditedId) {
      console.log('loadPlayListEditor', { id: playListEditedId })
      this.playListEditedId = playListEditedId
    }
  },
  computed: {
    noExceptionsInNetwork () {
      return this.mediaExceptionsForbidden && this.mediaExceptionsForbidden.length === 0 && this.mediaExceptionsAllowed && this.mediaExceptionsAllowed.length === 0
    }
  }
}
</script>
<style lang="scss">
@import "../../../theme-m4b/src/common/var.scss";
</style>



// WEBPACK FOOTER //
// src/components/Medium/MediaExceptions.vue